export const img_src = new URL('../img/proxy-1.jpg', import.meta.url);

export function ProxyImg1() {
  return <img src={img_src} className="h-auto mb-8 self-center rounded-lg shadow-xl" />;
}

# Quick Demo

Using context7 mcp with LM Studio and Gemma (~30 tokens/second)


<ProxyImg1 />
